import { render, staticRenderFns } from "./SalaPrensa.vue?vue&type=template&id=7572c4fa&scoped=true"
import script from "./SalaPrensa.vue?vue&type=script&lang=js"
export * from "./SalaPrensa.vue?vue&type=script&lang=js"
import style0 from "./SalaPrensa.vue?vue&type=style&index=0&id=7572c4fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7572c4fa",
  null
  
)

export default component.exports